module.exports = __webpack_public_path__ + "img/TaktNews-ProjectStructureTwo.1ceef28f.png";